import React from "react";

import Dialog, { DialogTitle, DialogContent, DialogActions } from "components/common/Dialog";
import CustomButton from "components/common/Button";
import DaySummaryCard from "components/CheckInCheckOut/DaySummaryCard/DaySummaryCard";
import { DaySummary } from "components/CheckInCheckOut/types";
import SectionLoader from "components/common/SectionLoader";

interface EndDayModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  daySummary: DaySummary;
  title?: string;
  description?: string;
  summaryTitle?: string;
  employeeName?: string;
  date?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  cancelVariant?: "text" | "outlined" | "contained";
  confirmVariant?: "text" | "outlined" | "contained";
  confirmColor?: "primary" | "error" | "secondary" | "success" | "warning";
  isLoading?: boolean;
}

function EndDayModal({
  open,
  onClose,
  onConfirm,
  daySummary,
  title = "Are you sure you want to end your day?",
  description = "Once ended, you won't be able to clock back in until the next shift starts.",
  summaryTitle = "Your day's summary",
  employeeName,
  date,
  cancelLabel = "Cancel",
  confirmLabel = "Yes, End Day",
  cancelVariant = "text",
  confirmVariant = "contained",
  confirmColor = "error",
  isLoading = false,
}: EndDayModalProps) {
  const dialogTitle = <DialogTitle title={title} />;

  const dialogContent = (
    <DialogContent>
      {description && <p className="para-body-m-regular color-text-body-primary mb-1">{description}</p>}
      {isLoading ? (
        <SectionLoader size={24} />
      ) : (
        <DaySummaryCard daySummary={daySummary} title={summaryTitle} employeeName={employeeName} date={date} />
      )}
    </DialogContent>
  );

  const dialogActions = (
    <DialogActions
      action1={
        <CustomButton size="large" label={cancelLabel} onClick={onClose} variant={cancelVariant} color="primary" />
      }
      action2={
        <CustomButton
          size="large"
          label={confirmLabel}
          onClick={onConfirm}
          variant={confirmVariant}
          color={confirmColor}
        />
      }
    />
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="xs"
      fullWidth={false}
      title={dialogTitle}
      content={dialogContent}
      actions={dialogActions}
    />
  );
}

export default EndDayModal;
